export default __webpack_public_path__ + "static/media/FEROZ.07c0f1cb.png";